import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BluetoothAudioIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bluetooth_audio"}/>
}
